// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"17d2e467","89":"a41c9567","195":"4c9e1484","205":"19e76aa5","274":"b46c3cdc","353":"577fbe47","546":"75843d38","678":"33eb4dd5","744":"83518688","885":"7589ca0a","963":"fcb49c84"}[chunkId] + ".chunk.js";
};